<template>
  <div class="pentagon-drawing-container">
    <img 
      :src="imageUrl" 
      alt="Pentagon drawing" 
      class="pentagon-image"
      v-if="imageUrl"
      @error="handleImageError"
    />
    <p v-if="!imageUrl" class="no-drawing-message">No drawing available for this subject</p>
  </div>
</template>

<script>
export default {
  name: 'PentagonDrawing',
  computed: {
    imageUrl() {
      const subjectId = localStorage.getItem('currentSubjectId') || localStorage.getItem('subjectId');
      if (!subjectId) return null;

      const drawingMap = {
        'ACTB117': 'ACTB117_003_003_000_SubmittedDrawing_25_01_17_09_54_09.png',
        'Actb118': 'Actb118_003_003_000_SubmittedDrawing_25_01_17_11_08_54.png',
        'Actb119': 'Actb119_003_003_000_SubmittedDrawing_25_01_17_13_14_01.png',
        'Actb120': 'Actb120_003_003_000_SubmittedDrawing_25_01_17_14_18_05.png',
        'ACTB126': 'ACTB126_003_003_000_SubmittedDrawing_25_02_14_12_24_03.png',
        'actb140': 'actb140_003_003_000_SubmittedDrawing_25_03_21_10_44_54.png',
        'ACTB198': 'ACTB198_003_003_000_SubmittedDrawing_24_12_13_10_24_35.png',
        'ACTB199': 'ACTB199_003_003_000_SubmittedDrawing_24_12_13_11_12_59.png',
        'ACTI109': 'ACTI109_003_003_000_SubmittedDrawing_24_12_12_11_43_10.png',
        'ACTI110': 'ACTI110_004_003_000_SubmittedDrawing_25_01_09_11_19_12.png',
        'ACTI111': 'ACTI111_004_003_000_SubmittedDrawing_25_01_09_10_46_39.png',
        'ACTI112': 'ACTI112_004_003_001_SubmittedDrawing_25_01_21_13_40_03.png',
        'Acti113': 'Acti113_004_003_000_SubmittedDrawing_25_01_24_10_02_20.png'
      };

      let filename = drawingMap[subjectId];
      
      if (!filename) {
        const lowerSubjectId = subjectId.toLowerCase();
        const matchingKey = Object.keys(drawingMap).find(key => key.toLowerCase() === lowerSubjectId);
        if (matchingKey) {
          filename = drawingMap[matchingKey];
        }
      }
      
      if (!filename) return null;
      
      return `https://braingamecenter.s3.us-east-2.amazonaws.com/ACT_PILOTB_2024_10_pentagon_scoring/${filename}`;
    }
  },
  methods: {
    handleImageError(event) {
      console.error('Failed to load pentagon drawing image:', event);
      event.target.style.display = 'none';
    }
  }
};
</script>

<style scoped>
.pentagon-drawing-container {
  margin: 20px 0;
  text-align: center;
}

.pentagon-image {
  max-width: 100%;
  max-height: 400px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.no-drawing-message {
  color: #666;
  font-style: italic;
}
</style>

